import {
  buildCompanyMachinesListFromGateways,
  transformGatewaysWithMachinesToGatewaysList,
} from "../entities/transform-gateways-with-machines-response";
import {
  setAllMachinesWithGatewaysListData,
  setConnectedGatewaysWithMachinesListData,
  setGatewaysWithMachinesError,
  setGatewaysWithMachinesResultsReady,
  setMachinesWithGatewaysShowSearchBar,
} from "@src/reducers/gateways-machines-slice";
import store from "@src/reducers/store";
import { loadGatewaysWithMachinesData } from "./load-gateways-with-machines-data";

const clearGatewaysMachinesListData = () => {
  store.dispatch(setConnectedGatewaysWithMachinesListData([]));
  store.dispatch(setAllMachinesWithGatewaysListData({}));
  store.dispatch(setMachinesWithGatewaysShowSearchBar(false));
};

export const loadGatewaysMachinesPageData = async () => {
  store.dispatch(setGatewaysWithMachinesError(null));

  try {
    const result = await loadGatewaysWithMachinesData();

    if (!result.success || !result.data) {
      clearGatewaysMachinesListData();
      store.dispatch(
        setGatewaysWithMachinesError(
          result.error || "Failed to load gateways with machines.",
        ),
      );
      return;
    }

    // Pagination is not handled yet; the endpoint currently returns the full list.
    const transformedGateways = transformGatewaysWithMachinesToGatewaysList(
      result.data,
    );
    const companyName =
      store.getState().yourSlice.authContext?.organization || "";
    const allMachinesListData = companyName
      ? buildCompanyMachinesListFromGateways(companyName, transformedGateways)
      : {};
    const machineCount = Object.values(
      allMachinesListData[companyName]?.machines ?? {},
    ).length;

    store.dispatch(
      setConnectedGatewaysWithMachinesListData(transformedGateways),
    );
    store.dispatch(setAllMachinesWithGatewaysListData(allMachinesListData));
    store.dispatch(setMachinesWithGatewaysShowSearchBar(machineCount > 0));
  } catch (error) {
    clearGatewaysMachinesListData();
    store.dispatch(
      setGatewaysWithMachinesError(
        error instanceof Error
          ? error.message
          : "Failed to load gateways with machines.",
      ),
    );
  } finally {
    store.dispatch(setGatewaysWithMachinesResultsReady(true));
  }
};
